import { CaretDownFilled, CaretUpFilled, LineOutlined } from "@ant-design/icons";
import Icon from "@assets/icon_config";
import { Button } from "antd";
import CustomTooltip from "@pages/tool-tip";
import React from "react";
import { Factor as FactorType, UseRisksContext } from "../useRisks";
import './factor.scss';

const formatters = {
  number: (value: number) => value,
  percent: (value: number) => `${value}%`,
  cost: (value: number) => `$ ${value.toLocaleString()}`,
  hcc: (value: number) => `${value.toFixed(3)}`
}

const statusSymbols = {
  increase: <CaretUpFilled />,
  decrease: <CaretDownFilled />,
  same: <LineOutlined />
}

export const FactorComponent: React.FC<{  type: string; factor: FactorType; openDetails?: (type: string, factor: number) => void }> = function ({ type, factor, openDetails }) {
  if (factor.name.toLowerCase().includes('hcc')) {
    factor.type = 'hcc'
  }

  const formatter = formatters[factor.type] || formatters['number']

  return <div className="ui-factor">
    <div className="ui-factor__header">
      <div className="ui-factor__header__title">
        <CustomTooltip toolTipvalue={factor.name}>
          {factor.name}
        </CustomTooltip>
      </div>
      <div className="ui-factor__header__action">
        <Button
          type="link"
          disabled={!factor.enableDetails}
          onClick={
            e => {
              openDetails && openDetails(type, factor.id)
            }
          }
        >
          <Icon name="showDetails" />
        </Button>
      </div>
    </div>
    <div className="ui-factor__main">
      <div className="ui-factor__main__impact-value">
        {factor.currentImpactPercent}%
      </div>
      {
        factor.type ?
          <div className="ui-factor__main__values">
            <div className="ui-factor__main__values__current">
              {factor.currentImpactValue !== null ? formatter(factor.currentImpactValue) : 'NA'}
            </div>
            {
              (factor.currentStatus !== null && factor.currentImpactValue !== null) ?
              <div className={`ui-factor__main__values__status ui-factor__main__values__status--${factor.flag} ${factor.currentImpactValue === factor.prevImpactValue ? 'grey-clr' : ''}`}>
                {
                  statusSymbols[factor.currentStatus]
                }
              </div> :
              <div>

              </div>
            }
            <div className="ui-factor__main__values__prev">
              {factor.prevImpactValue !== null ? formatter(factor.prevImpactValue) : 'NA'} (Prev.)
            </div>
          </div> :
          <div></div>
      }
      <div className="ui-factor__main__impact-description">
        Impact on Risk
      </div>
      <div className="ui-factor__main__values-description">
        {factor.currentImpactDescription}
      </div>
    </div>
  </div>
};

export const Factor = React.memo(FactorComponent, (prevProps, nextProps) => prevProps.type === nextProps.type && prevProps.factor === nextProps.factor)
